<h2 class="social-dialog-title" mat-dialog-title>
  {{ data.modalTitle }}
  <div
    class="dismiss close-x-button"
    (click)="closeDetail()"
    (keydown.enter)="closeDetail()"
    tabindex="0"
    aria-label="Close Dialog"
  >
    X
  </div>
</h2>
<mat-dialog-content>
  <p class="modal-text">
    You are not allowed to join this social. The host has enabled security measures that require you to belong to the
    same organization or to be a connection. You can update your organization from the
    <a target="__blank" routerLink="web/settings" href>Settings page</a>. You can add the host as a connection from the
    <a target="__blank" routerLink="web/connections">Connections page</a> or request to connect from his/her Portrait.
    You will need to know his/her contact information to add him/her as a connection.
  </p>

  <div class="center-element">
    @if (data.secondaryButtonText) {
      <button mat-raised-button (click)="secondaryButtonClicked()" class="social-modal-buttons">
        {{ data.secondaryButtonText }}
      </button>
    }
    @if (data.primaryButtonText) {
      <button
        mat-raised-button
        (click)="confirmButtonClicked()"
        class="social-modal-buttons social-modal-button-primary"
      >
        {{ data.primaryButtonText }}
      </button>
    }
  </div>
  <div style="text-align: center">
    @if (data.tertiaryButtonText) {
      <button (click)="cancelButtonClicked()" class="social-modal-buttons link-button">
        {{ data.tertiaryButtonText }}
      </button>
    }
  </div>
</mat-dialog-content>
